import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/modules/material.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PageNotFoundComponent } from './common/components/page-not-found/page-not-found.component';
import {
  aumyeReducer,
  metaReducers,
} from './state-management/reducers/entry.reducer';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CyclopsHttp } from './services/app.http';
import { ConstantSetterAndGetterService } from './app.constants';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { ToastrModule } from 'ngx-toastr';
import { AumyeResponsiveScreenService } from './services/screenResize/aumye-responsive-screen.service';
import { AumyeSharedScrollService } from './services/screenScrolling/shared-scroll.service';
import { initializeApp } from 'firebase/app';
import { environment } from './environments/environments';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { PushNotificationService } from './services/push-notification-service.service';
import { AumyeRealTimeNotificationService } from './services/aumye-real-time-notification.service';
import { BrouserPrinter } from './services/printer/printer';
import { ApiInterceptor } from './services/interceptors/api.interceptor';

initializeApp(environment.firebaseConfig);

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    DashboardModule,
    HttpClientModule,
    EffectsModule.forRoot([]),
    StoreModule.forRoot(aumyeReducer, { metaReducers }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireMessagingModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    CyclopsHttp,
    ConstantSetterAndGetterService,
    AumyeResponsiveScreenService,
    AumyeSharedScrollService,
    PushNotificationService,
    AumyeRealTimeNotificationService,
    BrouserPrinter,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
